import { render, staticRenderFns } from "./DeleteGasto.vue?vue&type=template&id=5b814442&scoped=true"
import script from "./DeleteGasto.vue?vue&type=script&lang=js"
export * from "./DeleteGasto.vue?vue&type=script&lang=js"
import style0 from "./DeleteGasto.vue?vue&type=style&index=0&id=5b814442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b814442",
  null
  
)

export default component.exports